import consumer from "./consumer";

export default class AirtableChannel extends EventTarget {
  channel = null
  messageQueue = []

  connect = () => {
    const $this = this;
    return new Promise((resolve, reject) => {
      this.channel = consumer.subscriptions.create("AirtableChannel",
        {
          connected: () => {
            resolve(this);
            $this.performQueue();
          },
          received(data) {
            const messageType = data.type || "message";
            $this.dispatchEvent(new CustomEvent(messageType, {detail: data}));
          },
          rejected(err) {
            reject(err);
            console.warn('rejected', err);
          }
        }
      );
    })
  }

  disconnect = () => {
    this.channel?.unsubscribe();
  }

  sync = (collection) => {
    this.perform("sync", {collection});
  }

  getBaseList = () => {
    this.perform("getBaseList");
  }

  update = (airtableIntegrationAttrs) => {
    this.perform('update', airtableIntegrationAttrs);
  }

  perform = (...args) => {
    if (this.channel) {
      this.channel.perform(...args);
    } else {
      this.messageQueue.push(() => this.perform(...args))
    }
  }

  performQueue = () => {
    const message = this.messageQueue.shift();
    if (message) {
      message();
      this.performQueue();
    }
  }
}
